module.exports = __webpack_public_path__ + "static/img/ohc-blocky.d6d29ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event/oneHourCode/ohc-blocky.jpg
// module id = 2YPX
// module chunks = 1